<template>

  <div class="container" :key="fullCode">
    <fullPage @leaveSlide="leaveSlide" :currentParent="fullIndex" ref="fullPage">
      <div slot="section" class="container">
        <college-first :currentIndex="currentIndex"></college-first>
      </div>
      <div slot="section" class="container">
        <college-second :currentIndex="currentIndex"></college-second>
      </div>
      <div slot="section" class="container">
        <college-third :currentIndex="currentIndex"></college-third>
      </div>
      <div slot="section" class="container">
        <college-fourth :currentIndex="currentIndex"
                        @scrollListener="scrollListener"></college-fourth>
      </div>
    </fullPage>
  </div>
</template>

<script>

  import collegeFirst from '@/page/college/components/CollegeFirst'
  import collegeSecond from '@/page/college/components/CollegeSecond'
  import collegeThird from '@/page/college/components/CollegeThird'
  import collegeFourth from '@/page/college/components/CollegeFourth'
  import fullPage from '@/components/fullPage'
  import merge from 'webpack-merge'

  export default {
    name: "College",
    data() {
      return {
        fullIndex: 0,
        fullCode: 0,
        currentIndex: 1,
        lastIndex: 2,
      }
    },

    components: {
      collegeFirst,
      collegeSecond,
      collegeThird,
      collegeFourth,
      fullPage,
    },

    mounted() {
      this.fullIndex = parseInt(this.$route.query.index)
      console.log('this.$route.query.index---', this.fullIndex)
    },

    watch: {
      '$route': function (newUrl, oldUrl) {
        if (newUrl != oldUrl && this.$store.state.isSlide) {
          console.log('this.$route.query.index---', this.$route.query.index)
          this.fullCode = parseInt(this.$route.query.index)
          this.fullIndex = parseInt(this.$route.query.index)
          console.log('this.$route.query.fullIndex---', this.fullIndex)
        }
      }
    },


    methods: {
      leaveSlide(item) {
        this.currentIndex = item.currentIndex
        this.lastIndex = item.currentIndex
        this.$router.push({
          query:merge(this.$route.query,{index:item.currentIndex})
        })
        this.$store.commit('slideEdit',false)
        this.$store.commit('edit',item.currentIndex - 1)
        if (item.currentIndex == 4) {
          this.$refs.fullPage.api.setAllowScrolling(false)
        }
      },
      scrollListener(e) {
        this.$refs.fullPage.api.setAllowScrolling(true)
      },
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/college/College.vue